(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pet-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bars = document.querySelectorAll('[data-pss-sticky]');
    bars.forEach(function(bar) {
      if (bar.dataset.pssBound) return;
      bar.dataset.pssBound = '1';
      var trigger = parseInt(bar.getAttribute('data-pss-trigger') || '600', 10);
      var lastShown = false;
      var onScroll = function() {
        var show = window.scrollY > trigger;
        if (show !== lastShown) {
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          lastShown = show;
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });

    var popups = document.querySelectorAll('[data-pss-popup]');
    popups.forEach(function(popup) {
      if (popup.dataset.pssBound) return;
      popup.dataset.pssBound = '1';

      var openers = document.querySelectorAll('[data-pss-popup-open][aria-controls="' + popup.id + '"]');

      function open() {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.classList.add('pss-popup-open');
      }
      function close() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('pss-popup-open');
      }

      openers.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          open();
        });
      });

      popup.addEventListener('click', function(e) {
        if (e.target === popup) close();
        if (e.target.closest && e.target.closest('[data-pss-popup-close]')) close();
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
      });

      function openCart() {
        window.dispatchEvent(new CustomEvent('opencart'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        return true;
      }

      popup.querySelectorAll('[data-pss-atc]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var vid = parseInt(btn.getAttribute('data-variant'), 10);
          if (!vid || isNaN(vid)) return;
          var original = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          })
          .then(function(r) {
            if (!r.ok) return r.json().then(function(err) { throw new Error(err.description || 'Add failed'); });
            return r.json();
          })
          .then(function() {
            btn.textContent = 'Added';
            close();
            openCart();
            setTimeout(function() { btn.disabled = false; btn.textContent = original; }, 1800);
          })
          .catch(function(err) {
            btn.textContent = (err && err.message) ? err.message.slice(0, 40) : 'Try again';
            setTimeout(function() { btn.disabled = false; btn.textContent = original; }, 2400);
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
